export default __webpack_public_path__ + "static/media/animajca-koder29.06OK.800f91ba.mp4";